import { useState } from 'react'
import { BOOK_JOKES } from '@data/jokes'

export default function JokeCarousel() {
  const [jokeIndex, setJokeIndex] = useState(0)
  const [revealed, setRevealed] = useState(false)

  const joke = BOOK_JOKES[jokeIndex]

  const handleReveal = () => {
    setRevealed(true)
  }

  const handleNext = () => {
    setJokeIndex((jokeIndex + 1) % BOOK_JOKES.length)
    setRevealed(false)
  }

  return (
    <div className="joke-carousel">
      <blockquote className="joke-carousel__quote">
        <p className="joke-carousel__setup">"{joke.setup}"</p>
        {revealed ? (
          <p className="joke-carousel__punchline">"{joke.punchline}"</p>
        ) : (
          <button
            type="button"
            className="joke-carousel__reveal-btn"
            onClick={handleReveal}
          >
            Reveal the punchline!
          </button>
        )}
        <cite className="joke-carousel__citation">{joke.citation}</cite>
      </blockquote>
      <button
        type="button"
        className="joke-carousel__next-btn"
        onClick={handleNext}
      >
        Next Joke
      </button>
    </div>
  )
}
